<template>
    <div class="aba-cliente">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div class="column" :class="[permissaoPropriedade.create ? 'is-6' : 'is-8']">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-propriedades"
                    />
                </div>
                <div class="column" :class="[permissaoPropriedade.create ? 'is-3' : 'is-4']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissaoPropriedade.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'agro-propriedade-new',
                                query: {
                                    tela: 'cliente-propriedade',
                                    id: $route.params.id,
                                    name: $route.params.name,
                                    dadoscadastrais: 5,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-propriedade') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="propriedadesList"
                    class="data-table"
                    @sort="loadSort"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.field"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :sortable="f.sortable"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'nome'">
                            <router-link
                                :to="{
                                    name: 'agro-propriedade-edit',
                                    params: { id: props.row.uuid },
                                    query: { tela: 'cliente-propriedade', id: $route.params.id },
                                }"
                                v-if="permissaoPropriedade.update"
                            >
                                {{ props.row[f.key] }}
                            </router-link>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </div>
                        <div v-else-if="f.key == 'excluir'" class="no-strike">
                            <b-field :addons="false">
                                <b-button
                                    v-if="props.row.situacao && permissaoPropriedade.update"
                                    type="is-danger"
                                    icon-right="delete"
                                    @click="promptForDelete(props.row)"
                                    v-tippy
                                    :title="$t('desativar-propriedade')"
                                />
                                <b-button
                                    v-else-if="permissaoPropriedade.update"
                                    class="ml-1"
                                    type="is-success"
                                    icon-right="check"
                                    @click="promptForCompletion(props.row)"
                                    v-tippy
                                    :title="$t('reativar-propriedade')"
                                />
                            </b-field>
                        </div>

                        <div v-else-if="f.field == 'descricaounidademedidaarea'">
                            {{ props.row[f.key] + ' (' + props.row.sigla + ')' }}
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row.situacao"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
//SERVICES
import PropriedadeService from '@/services/agro/PropriedadeService';
import VendasClienteService from '@/services/VendasClienteService';
// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/* @70954 */
export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            propriedadesList: [],
            fields: [
                { key: 'nome', field: 'nome', sortable: true },
                {
                    key: 'unidade-medida-area',
                    field: 'descricaounidademedidaarea',
                    sortable: true,
                },
                { key: 'area-total', field: 'areaTotal', sortable: true },
                { key: 'replicapda', field: 'situacao', width: 80 },
                { key: 'excluir', label: 'situacao', sortable: false },
            ],
            servicePropriedade: new PropriedadeService(this.$http, this.$router),
            serviceVendasCliente: new VendasClienteService(this.$http, this.$router),
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            delete: null,
            uuid: null,
            active: 0,
            permissaoCadastrar: false,
            permissaoPropriedade: false,

            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },

    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissaoPropriedade = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'agro-propriedade'
        );

        if (!this.permissaoPropriedade.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cliente' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },

    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.loadPropriedades(
                this.$route.params.id,
                currentPage - 1,
                this.pagination.perPage,
                this.column,
                this.order,
                this.situacaoSelected.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.propriedadesList = Object.assign([], value);
                    this.isEmpty = this.propriedadesList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as tabelas de propriedade');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        loadPropriedades(idCliente, page, limit, column, order, situacao, ...params) {
            if (this.isVenda) {
                return this.serviceVendasCliente.loadPropriedadesVendas(
                    idCliente,
                    page,
                    limit,
                    column,
                    order,
                    situacao,
                    ...params
                );
            } else {
                return this.serviceVendasCliente.loadPropriedadesAgro(
                    idCliente,
                    page,
                    limit,
                    column,
                    order,
                    situacao,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idpropriedade: m.idpropriedade,
                    uuid: m.uuid,
                    nome: m.nome,
                    'unidade-medida-area': m.unidadeMedida.descricao,
                    sigla: m.unidadeMedida.sigla,
                    situacao: m.situacao,
                    'area-total': m.areaTotal,
                };
            });
        },

        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        loadSort(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptForDelete(row) {
            this.delete = row;
            this.active = 2;
            this.$root.confirm({
                message: this.$t('msg-confirmacao-desativacao-n', { n: row.nome }),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        promptForCompletion(row) {
            this.delete = row;
            this.active = 1;
            this.$root.confirm({
                message: this.$t('msg-confirmacao-reativacao-n-propriedade', { n: row.nome }),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },

        updateSituacaoRegistro() {
            this.isLoading = true;

            this.servicePropriedade
                .changeSituacao(this.delete.uuid)
                .then((r) => {
                    if (this.active == 1) {
                        this.$root.showMessage('success', 'msg-reativou-propriedade');
                    } else if (this.active == 2) {
                        this.$root.showMessage('success', 'msg-inativou-propriedade');
                    }

                    this.loadSort(this.column, this.order);
                })
                .catch((e) => {
                    console.error('Erro ao remover propriedade.', e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-cliente {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
.data-table .ml-1 {
    margin-left: 0 !important;
}
</style>
